<template>
    <div>
        <div class="card p-3">
            <div class="card-block">
                <form autocomplete="off" @submit.prevent="getAlumnosObservaciones()">
                    <vs-row>
                        <vs-col w="12" class="mb-3">
                            <breadcrumbs :ruta="'observaciones'"></breadcrumbs>
                            <h4 class="mt-4 p-2">Observaciones</h4>
                        </vs-col>
                        <vs-col sm="12" lg="3" class="mb-3">
                            <vs-select :loading="loadingCiclo" class="pt-0" label="Ciclo Escolar" placeholder="Seleccionar Ciclo Escolar" :key="cicloId" v-model="cicloEscolar" :disabled="!ciclosEscolares.length" @input="changeInfo('ciclo')">
                                <vs-option v-for="option in ciclosEscolares" :key="option.id"  :label="option.nombre_ciclo" :value="option.id">
                                    {{option.nombre_ciclo}}
                                </vs-option>
                                <template #message-danger v-if="errorFields.includes('cicloEscolar')">
                                    Requerido
                                </template>
                            </vs-select>
                        </vs-col>
                        <vs-col sm="12" lg="3" class="mb-3">
                            <vs-select :loading="loadingInstitucion" class="pt-0" label="Institución" placeholder="Seleccionar Institucion" :key="institucionId" v-model="institucion" :disabled="!instituciones.length" @input="changeInfo('institucion')">
                                <vs-option v-for="option in instituciones" :key="option.id"  :label="option.nombre" :value="option.id">
                                    {{option.nombre}}
                                </vs-option>
                                <template #message-danger v-if="errorFields.includes('institucion')">
                                    Requerido
                                </template>
                            </vs-select>
                        </vs-col>
                        <vs-col sm="12" lg="3" class="mb-3">
                            <vs-select :loading="loadingPrograma" class="pt-0" label="Programa" placeholder="Seleccionar Programa" :key="programaId" v-model="programa" :disabled="!programas.length" @input="changeInfo('programa')">
                                <vs-option v-for="option in programas" :key="option.id"  :label="option.nombre" :value="option.id">
                                    {{option.nombre}}
                                </vs-option>
                                <template #message-danger v-if="errorFields.includes('programa')">
                                    Requerido
                                </template>
                            </vs-select>
                        </vs-col>
                        <vs-col sm="12" lg="3" class="mb-3">
                            <vs-select :loading="loadingPeriodo" class="aqui pt-0" label="Periodo" placeholder="Seleccionar Periodo" :key="periodoId" v-model="periodo" :disabled="!periodos.length" @input="changeInfo('periodo')">
                                <vs-option v-for="option in periodos" :key="option.detalle_componente_id"  :label="option.nombre" :value="option.detalle_componente_id">
                                    {{option.nombre}}
                                </vs-option>
                                <template #message-danger v-if="errorFields.includes('periodo')">
                                    Requerido
                                </template>
                            </vs-select>
                        </vs-col>
                        <vs-col sm="12" lg="3" v-if="modoCaptura == 'lista'">
                            <vs-select :loading="loadingCodigo" label="Código de sesión" class="pt-0" placeholder="Seleccionar Código de sesión" :key="codigoId" v-model="codigo" :disabled="!codigos.length" @input="changeInfo('codigo')">
                                <vs-option v-for="option in codigos" :key="option.codigo_sesion_id"  :label="option.asignatura" :value="option.codigo_sesion_id">
                                    {{option.asignatura}}
                                </vs-option>
                                <template #message-danger v-if="errorFields.includes('codigo')">
                                    Requerido
                                </template>
                            </vs-select>
                        </vs-col>
                        <vs-col sm="12" lg="3" class="mb-3">
                            <vs-select :loading="loadingGrupoAcademico" class="pt-0" label="Grupo Académico" placeholder="Seleccionar Grupo Académico" :key="grupoAcademicoId" v-model="grupoAcademico" :disabled="!grupoAcademicos.length">
                                <vs-option v-for="option in grupoAcademicos" :key="option.id"  :label="option.nombre" :value="option.id">
                                    {{option.nombre}}
                                </vs-option>
                                <template #message-danger v-if="errorFields.includes('grupoAcademico')">
                                    Requerido
                                </template>
                            </vs-select>
                        </vs-col>
                    </vs-row>
                    <vs-row>
                        <vs-col>
                        <vs-button
                            v-if="nivelAcademico == 2"
                            class="ml-auto"
                        >
                            <i class="fas fa-search mr-2"></i> Buscar
                        </vs-button>
                        </vs-col>
                    </vs-row>
                </form>
            </div>
        </div>
        <h4 v-if="showNivel" class="text-center mt-4">LAS OBSERVACIONES ÚNICAMENTE SE PUEDEN ASIGNAR A NIVEL PRIMARIA.</h4>
        <tabla-observaciones :refreshInfo="getAlumnosObservaciones" class="mt-4" :users="users" :arrayAlumnos="arrayAlumnos" :obser="obser" :institucion="institucion" :cicloEscolar="cicloEscolar"></tabla-observaciones>
    </div>
</template>

<script>

import evaluaciones from '../../../api/requests/docente/evaluaciones.js'
import TablaObservaciones from './tabla_observaciones.vue'
import breadcrumbs from '../beadcrumbs.vue'
export default {
  props: [ 'csrf_token' ],
  components: {
    TablaObservaciones,
    breadcrumbs
  },
  data() {
    return {
      cicloEscolar: '',
      ciclosEscolares: [],
      cicloId: (new Date()).getTime(),
      loadingCiclo: false,
      institucion: '',
      instituciones: [],
      institucionId: (new Date()).getTime(),
      loadingInstitucion: false,
      periodo: '',
      periodos: [],
      periodoId: (new Date()).getTime(),
      loadingPeriodo: false,
      programa: '',
      programas: [],
      programaId: (new Date()).getTime(),
      loadingPrograma: false,
      codigo: '',
      codigos: [],
      codigoId: (new Date()).getTime(),
      loadingCodigo: false,
      grupoAcademico: '',
      grupoAcademicos: [],
      grupoAcademicoId: (new Date()).getTime(),
      loadingGrupoAcademico: false,
      modoCaptura: '',
      nivelAcademico: '',
      showNivel: false,
      obser: [],
      users:{},
      arrayAlumnos: [],
      errorFields: []
    }
  },
  async created() {
    this.getciclosEscolaresDocente()
  },
  methods: {
    
    changeInfo(valor){
      if(valor == 'ciclo'){
        this.institucion = ''
        this.programa = ''
        this.periodo = ''
        this.codigo = ''
        this.grupoL = ''
        this.grupoS = ''
        this.users = {}
        this.sabana = []
      }
      if(valor == 'institucion'){
        this.programa = ''
        this.periodo = ''
        this.codigo = ''
        this.grupoL = ''
        this.grupoS = ''
        this.users = {}
        this.sabana = []
      }
      if(valor == 'programa'){
        this.periodo = ''
        this.codigo = ''
        this.grupoL = ''
        this.grupoS = ''
        this.users = {}
        this.sabana = []
      }
      if(valor == 'periodo'){
        this.codigo = ''
        this.getCodigoSesion()
        this.grupoL = ''
        this.grupoS = ''
        this.users = {}
        this.sabana = []
      }
      if(valor == 'codigo'){
        this.grupoL = ''
        this.grupoS = ''
        this.users = {}
        this.sabana = []
      }
    },
    async getInstitucionDocente(){
      try {
          this.loadingInstitucion = true
          const { data: response } = await evaluaciones.getInstitucionDocente()
          this.instituciones = response
          if(response.length == 1){
            this.institucion = response[0].id
          }
          this.institucionId = (new Date()).getTime()
          this.loadingInstitucion = false
      }catch(error){
            console.log(error.response)
            this.$vs.notification({
            color: "warn",
            title: 'Hubo un error',
            text: error.response.data.message ? error.response.data.message : 'Favor de comunicarse con el administrador'
          })
        }
    },
    async getciclosEscolaresDocente(){
      try {
          this.loadingCiclo = true
          const { data: response } = await evaluaciones.getciclosEscolaresDocente()
          this.ciclosEscolares = response
          this.cicloId = (new Date()).getTime()
          this.loadingCiclo = false
      }catch(error){
            console.log(error.response)
            this.$vs.notification({
            color: "warn",
            title: 'Hubo un error',
            text: error.response.data.message ? error.response.data.message : 'Favor de comunicarse con el administrador'
          })
        }
    },
    async getProgramaDocentes(){
      try {
        this.loadingPrograma = true
        const params = {
          ciclo_escolar_id: this.cicloEscolar,
          institucion_id: this.institucion
        }
          const { data: response } = await evaluaciones.getProgramaDocentes(params)
          if(response.length == 1){
            this.programa = response[0].id
          }
          this.programas = response
          this.programaId = (new Date()).getTime()
         this.loadingPrograma = false
      }
      catch{
         this.loadingPrograma = false
      }
    },
    permisoAsignarObservaciones(){
      const vm = this
      const nivel = this.programas.forEach(p => {
        if(p.id == vm.programa){
          vm.nivelAcademico = p.nivel_academico_id
          if(p.nivel_academico_id != 2){
            vm.showNivel = true
          }else{
            vm.showNivel = false
          }
        }
      })
    },
    async getPeriodosDocentes(){
      if(this.programa){
        try {
          this.loadingPeriodo = true
          const params = {
            ciclo_escolar_id: this.cicloEscolar,
            institucion_id: this.institucion,
            programa_id: this.programa
          }
          const { data: response } = await evaluaciones.getPeriodosDocentes(params)
          if(response.length == 1){
            this.periodo = response[0].detalle_componente_id
          }
          this.periodos = response
          this.periodoId = (new Date()).getTime()
          this.loadingPeriodo = false
        }catch(error){
            console.log(error.response)
            this.$vs.notification({
            color: "warn",
            title: 'Hubo un error',
            text: error.response.data.message ? error.response.data.message : 'Favor de comunicarse con el administrador'
          })
        }
      }
    },
    async getModoCaptura(){
      if(this.periodo){
        try {
          const params = {
            ciclo_escolar_id: this.cicloEscolar,
            detalle_componente_id: this.periodo,
            institucion_id: this.institucion
          }
          const { data: response } = await evaluaciones.getModoCaptura(params)
            this.modoCaptura = response
        }
        catch(error){
          this.$vs.notification({
            progress: 'auto',
            color: 'danger',
            position: null,
            title: 'Error',
            text: 'No existe configuracion para evaluar este periodo.'
          })
        }
      }
    },
    async getCodigoSesion(){
      if(this.periodo){
        try {
          this.loadingCodigo = true
          const params = {
            ciclo_escolar_id: this.cicloEscolar,
            institucion_id: this.institucion,
            programa_id: this.programa
          }
          const { data: response } = await evaluaciones.getCodigoSesion(params)
          this.codigos = response
          this.codigoId = (new Date()).getTime()
          this.loadingCodigo = false
        }
        catch{

        }
      }
    },
    async getGrupoAcademico(){
        try {
          this.loadingGrupoAcademico = true
          const params = {
            ciclo_escolar_id: this.cicloEscolar,
            detalle_componente_id: this.periodo
          }
          let response = []
          if(this.modoCaptura == 'sabana'){
            params.programa_id = this.programa
            params.institucion_id = this.institucion
            response =  await evaluaciones.getGrupoAcademicoS(params)
          }else if(this.modoCaptura == 'lista'){
            params.codigo_sesion_id =  this.codigo
            response =  await evaluaciones.getGrupoAcademicoL(params)
          }
          if(response.data.length == 1){
            this.grupoAcademico = response.data[0].id
          }
          this.grupoAcademicos = response.data
          this.grupoAcademicoId = (new Date()).getTime()
          this.loadingGrupoAcademico = false
        }catch(error){
            console.log(error)
        //     this.$vs.notification({
        //     color: "warn",
        //     title: 'Hubo un error',
        //     text: error.response.data.message ? error.response.data.message : 'Favor de comunicarse con el administrador'
        //   })
      }
    },
    async getObsercaciones(){
      if(this.grupoAcademico){
        const campos_formativos = [
            { id: 1, text: 'Lenguajes'},
            { id: 2, text: 'Saberes y pensamiento científico'},
            { id: 3, text: 'Ética, naturaleza y sociedades'},
            { id: 4, text:'De lo humano y lo comunitario'}
        ]
        const vm = this
        const obj = []
        for (var i = 1; i < 5; i++) {
            try {
                const params = {
                    campo_formativo_id: i,
                }
                  this.grupoAcademicos.forEach(g => {
                    if(g.id == this.grupoAcademico){
                        params.grado_id = g.grado_id
                    }
                  })
                
                const array = { campo_formativo: '', campos_formativos: []}
                const { data: response } = await evaluaciones.getObsercaciones(params)
                array.campos_formativos = response
                campos_formativos.forEach(c => {if(c.id == i){array.campo_formativo = c.text}})
                obj.push(array)
            }catch(error){
                console.log(error.response)
                vm.$vs.notification({
                color: "warn",
                title: 'No se cuenta con observaciones en ' + campos_formativos.map(c => {
                    if(c.id == i){
                        return c.text
                    }
                })
            })
            }
        }
        this.obser = obj
      }
    },
    sanityForm () {
        this.errorFields = []
        if (!this.cicloEscolar) {
            this.errorFields.push('cicloEscolar')
        }
        if (!this.institucion) {
            this.errorFields.push('institucion')
        }
        if (!this.programa) {
            this.errorFields.push('programa')
        }
        if (!this.periodo) {
            this.errorFields.push('periodo')
        }
        if (!this.grupoAcademico) {
            this.errorFields.push('grupoAcademico')
        }
        if (!this.errorFields.length){
            return true
        } else {
            return null
        }
    },
    async getAlumnosObservaciones(){
      if(this.sanityForm()){
          const loading = this.$vs.loading({
              text: 'Cargando...'
          })
          try{
              const params = {
                  ciclo_escolar_id: this.cicloEscolar,
                  detalle_componente_id: this.periodo,
                  programa_id: this.programa,
                  institucion_id: this.institucion,
                  grupo_academico_id: this.grupoAcademico
              }
              const { data: response } = await evaluaciones.getAlumnoSabana(params)
              this.users = response
              this.arrayAlumnos = response.alumnos
              loading.close()
          }catch(erro){
              console.log(erro)
              loading.close()
          }
        }
    }
  },
  watch: {
    cicloEscolar(){
        this.getInstitucionDocente()
    },
    institucion(){
      this.getProgramaDocentes()
    },
    programa(){
      this.getPeriodosDocentes()
      this.permisoAsignarObservaciones()
    },
    periodo(){
      this.getModoCaptura()
      this.codigo = ''
      this.grupoAcademico = ''
      if(this.modoCaptura != ''){
        this.getGrupoAcademico()
      }
    },
    modoCaptura(){
      if(this.modoCaptura == 'lista'){
        this.getCodigoSesion()
      }
        this.getGrupoAcademico()
    },
    codigo(){
        this.getGrupoAcademico()
    },
    grupoAcademico(){
        this.getObsercaciones()
    }
  }
}

</script>


<style lang="scss" scoped>
.botonSelect{
    border-radius: 20px;
    padding: 0.7em 1.5em;
    background: #5499C7;
    color: white;
    box-shadow: rgba(41, 128, 185, 0.2) 0px 20px 25px -5px, rgba(41, 128, 185, 0.3) 0px 10px 10px -5px;
    cursor: pointer;
}
.botonNotSelect{
    padding: 0.7em 1.3em;
    background: #F8F9F9;
    color: #5499C7;
    box-shadow: 0 0.125rem 0.25rem rgba(31, 97, 141, 0.075) !important;
    cursor: pointer;
}
</style>
